var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    style: {
      transform: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1 13H2.946a1 1 0 110-2H12.1a1 1 0 110 2zm5.697.123a1 1 0 10-1.26 1.554l1.596 1.293H7.446c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5a3.493 3.493 0 003.228-2.147 1 1 0 10-1.843-.774 1.502 1.502 0 01-2.885-.58c0-.826.673-1.499 1.5-1.499h10.982l-1.89 1.533a1 1 0 001.26 1.553l3.932-3.19a1 1 0 000-1.553l-3.933-3.19zM7.446 7.97H18.28l-1.742 1.413a1 1 0 001.26 1.554l3.932-3.19a1 1 0 000-1.554l-3.932-3.19a1 1 0 00-1.26 1.554L18.28 5.97H7.446c-.827 0-1.5-.673-1.5-1.5a1.502 1.502 0 012.885-.58 1 1 0 101.844-.773A3.493 3.493 0 007.446.97c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
export default __webpack_public_path__ + "static/media/wind.bfe7c1723a950280dc6434d8e829de8c.svg";
export { ForwardRef as ReactComponent };